export const iconFontAwesomeCommunicationPoo = (
	<i className="fa-solid fa-poo"></i>
);
